<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
		<div class="ro-home-content">
			<div class="ro-home-content-box">
				<div
					style="width:1100px;background-color: white;padding:50px;margin: auto;box-shadow:0px 0px 20px #8a8a8a;">
					<!-- <img src="../static/picture/sf_test.png" style="width: 75%;"/> -->
					<div style="overflow: hidden;">
						<div class="section-title" style="padding:20px 0;background-color: white;margin-bottom: 0;">
							<h4>{{title}}</h4>
							<div
								style="height:50px;line-height: 50px;color:gray;font-size: 12px;text-align: left;border-bottom: 1px solid #F1F1F1;">
								<span>发布时间：<span style="font-size: 10px;">{{date}}</span></span>
								<span style="margin-left:20px">浏览次数：<span style="font-size: 10px;">{{watch_qty}}</span></span>
								<!-- <span style="float: right;" @click="show_wx = true">分享到：
									<img src="../static/picture/weixin.png" style="width:25px;"/>
								</span> -->
							</div>
						</div>
						<div style="text-align: left;padding:20px;">
							<div v-html="content" />
						</div>
						<div style="text-align: left;font-size: 12px;"  v-for="(attachment, index) in attachment_data" :key="index" >
							<!-- <a style="display: block;"> -->
								<!-- <el-link type="primary">{{attachment.attachment_url}}</el-link></a> -->
							<a :href="attachment.attachment_url"><el-link  type="primary">{{attachment.attachment_name}}</el-link></a>
						</div>
						<!-- 	<el-dialog
						  title="扫码关注"
						  :visible.sync="show_wx"
						  width="25%"
						  :before-close="handleClose">
						  <img src="../static/picture/weixin.png" style="width:50%;"/>
						</el-dialog> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		data() {
			return {
				show_wx: false,
				about_us: '',
				content:'',
				title:'',
				date:'',
				watch_qty:'',
				attachment_data:'',
			}
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
		mounted() {
			var id = this.$route.query.id
			this.get_notice(id)
		},
		methods: {
			get_notice(id) {
				var self = this
				var data = {
					'id': id
				}
				fetchPost('/ro/tec_search/website/notice/v1', data).then(response => {
					
						var content = response.data.content
						var title = response.data.title
						var date = response.data.date
						var watch_qty = response.data.watch_qty
						var attachment_data = response.data.attachment_data
						self.content = content
						self.title = title
						self.date = date
						self.watch_qty = watch_qty
						self.attachment_data = attachment_data
				})
			}
		}
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 20px 0;
		background-image: url(../assets/img/bg/bg-7.jpg);
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: cover;
	}

	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}
</style>